import React from 'react'

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import {Box, styled, useTheme} from '@mui/material'
import {MaterialDesignContent, SnackbarProvider} from 'notistack'

type Props = {
  children: React.ReactNode
}

export function SnackbarProviderWrapper({children}: Props) {
  const theme = useTheme()
  const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent-success': {
      backgroundColor: theme.palette.success.main,
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: theme.palette.error.main,
    },
    '&.notistack-MuiContent-warning': {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.warning.contrastText,
    },
    '&.notistack-MuiContent-info': {
      backgroundColor: theme.palette.info.main,
    },
  }))

  return (
    <SnackbarProvider
      preventDuplicate
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
      }}
      autoHideDuration={6000}
      iconVariant={{
        success: (
          <Box mr={1} display={'flex'}>
            <CheckCircleOutlineOutlinedIcon />
          </Box>
        ),
        info: (
          <Box mr={1} display={'flex'}>
            <InfoOutlinedIcon />{' '}
          </Box>
        ),
        warning: (
          <Box mr={1} display={'flex'}>
            <ReportProblemOutlinedIcon />{' '}
          </Box>
        ),
        error: (
          <Box mr={1} display={'flex'}>
            <ErrorOutlineOutlinedIcon />{' '}
          </Box>
        ),
      }}
    >
      {children}
    </SnackbarProvider>
  )
}
